<!-- 省市区选择 -->
<template>
  <div class="address-picker">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">{{ title }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="nx-vmic-address-picker-content">
            <div class="city-select-tab os-font-14-400" v-if="selectProvince || selectCity">
              <div
                :class="{ selected: currentLevel == 1 }"
                class="select-province"
                v-show="selectProvince"
                @click="selectTab(1)"
              >
                <span>{{ selectProvince }}</span>
              </div>
              <div
                :class="{ selected: currentLevel == 2 }"
                class="select-city"
                v-show="selectProvince"
                @click="selectTab(2)"
              >
                <span>{{ selectCity || '请选择' }}</span>
              </div>
              <div
                :class="{ selected: currentLevel == 3 }"
                class="select-district"
                v-show="selectCity && mode == 3"
                @click="selectTab(3)"
              >
                <span>{{ selectDistrict || '请选择' }}</span>
              </div>
            </div>
            <div
              :class="[
                'city-list os-font-14-400',
                { 'city-list-active': selectProvince || selectCity }
              ]"
              ref="citylistDom"
            >
              <div
                class="all-city-list"
                v-for="(value, key) in currentData"
                :key="key"
                v-show="currentLevel <= mode"
              >
                <span class="letter-flag" :id="'letter-category-' + key">{{ key }}</span>
                <div
                  :class="['city-name', { 'city-name-active': currentName == item.name }]"
                  :name="item.name"
                  v-for="(item, index) in value"
                  :key="index"
                  @click="selectArea(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="letter-touch-bar"
              @touchmove="touchLetterMove"
              @touchend="touchLetterEnd"
              ref="letterTouchBarDom"
            >
              <div
                :data-letter="key"
                class="letter"
                v-for="(value, key) in currentData"
                :key="key"
                @click="selectLetter(key, $event)"
              >
                {{ key }}
              </div>
            </div>
            <div class="letter-flag-highlight" v-show="key">{{ key }}</div>
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'addressPicker',
  props: {
    title: {
      type: String,
      default: '选择取件地址'
    },
    addressData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showPopup: false,
      hotCity: null,
      currentLevel: 1,
      selectProvince: '',
      selectCity: '',
      selectDistrict: '',
      currentData: null,
      currentName: '',
      key: '',
      mode: 3
    }
  },
  computed: {
    ...mapState('repair', ['pickerAddress', 'repairType'])
  },
  methods: {
    ...mapMutations('repair', ['SET_PICKER_ADDRESS']),
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.currentData = this.addressData
      if (this.pickerAddress.province) {
        for (let key in this.currentData) {
          let first = this.currentData[key]
          if (first && first.length > 0) {
            for (let i = 0; i < first.length; i++) {
              if (first[i].name == this.pickerAddress.province) {
                let second = first[i].subAddress
                for (let j in second) {
                  for (let k = 0; k < second[j].length; k++) {
                    if (this.pickerAddress.city == second[j][k].name) {
                      this.selectProvince = this.pickerAddress.province
                      this.selectCity = this.pickerAddress.city
                      this.selectDistrict = this.pickerAddress.district
                      if (!this.selectProvince && !this.selectCity && !this.selectProvince) {
                        this.currentName = ''
                        this.currentLevel = 1
                      }
                      if (this.selectDistrict && this.selectCity && this.selectProvince) {
                        this.currentLevel = 3
                        this.selectTab(3)
                      }
                      if (this.selectCity && this.selectProvince && this.mode == 2) {
                        this.currentLevel = 2
                        this.selectTab(2)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        this.selectProvince = ''
        this.selectCity = ''
        this.selectDistrict = ''
        this.currentName = ''
        this.currentLevel = 1
      }
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.SET_PICKER_ADDRESS({})
      this.showPopup = false
    },
    selectConfirm() {
      let result = {
        province: this.selectProvince,
        city: this.selectCity,
        area: this.selectDistrict,
        detailAddress: ''
      }
      this.$emit('selectConfirm', result)
      this.$nextTick(() => {
        this.closePopup()
      })
    },
    selectTab(index) {
      this.currentLevel = index
      if (index == 1) {
        this.currentData = this.addressData
        this.currentName = this.selectProvince
      }
      if (index == 2) {
        this.selectAreaFromTab2(this.selectProvince)
        this.currentName = this.selectCity
      }
      if (index == 3) {
        this.selectAreaFromTab3(this.selectCity)
        this.currentName = this.selectDistrict
      }
      this.$nextTick(() => {
        let activeDom = document.getElementsByName(this.currentName)[0]
        if (activeDom) {
          activeDom.scrollIntoView()
        } else {
          this.$nextTick(() => {
            this.$refs.citylistDom.scrollTop = 0
          })
        }
      })
    },
    selectAreaFromTab2(item) {
      this.currentData = this.addressData
      for (let key in this.currentData) {
        let first = this.currentData[key]
        for (let i = 0; i < first.length; i++) {
          if (item == first[i].name) {
            this.currentData = first[i].subAddress
            return
          }
        }
      }
    },
    selectAreaFromTab3(item) {
      this.currentData = this.addressData
      for (let key in this.currentData) {
        let first = this.currentData[key]
        for (let i = 0; i < first.length; i++) {
          let second = first[i].subAddress
          for (let j in second) {
            for (let k = 0; k < second[j].length; k++) {
              if (item == second[j][k].name) {
                this.selectProvince = first[i].name
                this.selectCity = second[j][k].name
                this.currentName = this.selectCity
                this.currentLevel = 3
                // 只有预约增加全部
                if (this.repairType == 1) {
                  this.currentData = Object.assign(
                    {},
                    { A: [{ areaId: '', name: '全部' }] },
                    second[j][k].subAddress
                  )
                } else {
                  this.currentData = second[j][k].subAddress
                }
                return
              }
            }
          }
        }
      }
    },
    selectArea(item) {
      if (this.currentLevel == 1) {
        this.currentData = item.subAddress
        this.selectProvince = item.name
        this.selectCity = ''
        this.selectDistrict = ''
        for (let key in this.currentData) {
          for (let i = 0; i < this.currentData[key].length; i++) {
            if (this.selectProvince == this.currentData[key][i].name) {
              this.currentLevel++
              this.selectArea(this.currentData[key][i])
              return
            }
          }
        }
      }
      if (this.currentLevel == 2) {
        // 只有预约增加全部
        if (this.repairType == 1) {
          this.currentData = Object.assign(
            {},
            { A: [{ areaId: '', name: '全部' }] },
            item.subAddress
          )
        } else {
          this.currentData = item.subAddress
        }
        this.selectCity = item.name
        this.selectDistrict = ''
        if (this.mode == 2) {
          this.selectConfirm()
          this.closePopup()
        }
      }
      if (this.currentLevel == 3) {
        this.selectDistrict = item.name
        this.selectConfirm()
        this.closePopup()
      }
      this.currentName = item.name
      if (this.currentLevel < 3) {
        this.currentLevel++
      }
      this.$nextTick(() => {
        this.$refs.citylistDom.scrollTop = 0
      })
    },
    selectLetter(key, event) {
      this.key = key
      let a = document.getElementById('letter-category-' + key)
      a && a.scrollIntoView()
      this.removeLetterActiveClass()
      event.target.classList.add('active')
      setTimeout(() => {
        this.key = ''
        this.removeLetterActiveClass()
      }, 2000)
    },
    touchLetterMove(e) {
      e.preventDefault() // 阻止滚动事件的发生
      let x = e.targetTouches[0].clientX
      let y = e.targetTouches[0].clientY
      let touchdom = document.elementFromPoint(x, y)
      let key = touchdom && touchdom.getAttribute('data-letter')
      this.removeLetterActiveClass()
      touchdom.classList.add('active')
      if (key) {
        this.key = key
        let a = document.getElementById('letter-category-' + key)
        a && a.scrollIntoView()
      }
    },
    touchLetterEnd() {
      setTimeout(() => {
        this.key = ''
        this.removeLetterActiveClass()
      }, 2000)
    },
    removeLetterActiveClass() {
      let letterDom = this.$refs.letterTouchBarDom.children
      let doms = Array.from(letterDom)
      if (doms && doms.length > 0) {
        doms.forEach(element => {
          element.classList.remove('active')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes progress {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.popup-wrap {
  overflow: hidden;
}

.popup-content {
  overflow: hidden !important;
}

.nx-vmic-address-picker-content {
  .city-select-tab {
    display: flex;
    align-items: center;
    color: #999;
    padding: 12px 16px 12px;
    box-sizing: border-box;
    min-height: 48px;

    .select-province,
    .select-city,
    .select-district {
      max-width: calc(33.33% - 23px);
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      line-height: 16px;
      padding-bottom: 7px;
      margin-right: 21px;
      flex-shrink: 0;
      box-sizing: border-box;

      &.selected {
        color: #333;

        span {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            animation: progress 0.3s ease-in-out forwards;
            width: 100%;
            height: 5px;
            left: 0;
            bottom: -7px;
            background-color: #415fff;

            .vivo-dark-mode & {
              background-color: #3a56e6;
            }
          }
        }
      }
    }

    .select-district {
      margin-right: 0;
    }
  }

  .city-list {
    padding: 0 16px 0;
    box-sizing: border-box;
    overflow-y: auto;
    max-height: calc(90vh - 90px);
    height: 444px;

    &.city-list-active {
      max-height: calc(75vh - 100px);
      height: 400px;

      .all-city-list:first-of-type {
        margin-top: 16px;
      }
    }

    .all-city-list {
      position: relative;

      &:first-of-type {
        margin-top: 12px;
      }

      .letter-flag {
        position: absolute;
        width: 10px;
        top: 0;
        left: 0;
        font-size: 14px;
        color: #999999;
        height: 19px;
        display: flex;
        align-items: center;
      }

      .city-name {
        position: relative;
        font-size: 14px;
        color: #333333;
        padding: 0 0 24px 22px;
        line-height: 19px;
        display: flex;
        align-items: center;
      }

      .city-name-active {
        color: #415fff;
      }
    }
  }

  .letter-touch-bar {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 9px;
    margin: auto;
    // width: 34px;
    color: #ccc;

    .letter {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      width: 16px;
      height: 16px;
      border-radius: 3px;
      margin-bottom: 4px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .active {
      border-radius: 3px;
      background: #eaeaea;
    }
  }

  .letter-flag-highlight {
    position: absolute;
    width: 34px;
    height: 34px;
    right: 39px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 12px;
    color: #ffffff;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #415fff;

    .vivo-dark-mode & {
      background-color: #3a56e6;
    }
  }
}
</style>
